export default __webpack_public_path__ + "static/media/IVI-android.c207eac2.jpg";